import React, { useContext, useEffect, useState } from 'react'
import { CheckSquare, Square } from 'react-bootstrap-icons'
import Data from '../../../../../libs/api/services/Data'
import RTEMessageBuilderComponentNew from '../../../messaging/admin/components/RTEMessageBuilderComponentNew'
import QuestionnaireBuilderContext from '../QuestionnaireBuilderProvider'
import { AdminEditText, AdminLayoutWrapper, CommonLayoutWrapper } from './QBuilderComponentMultiSelect'

export default function QBuilderComponentDisplayText({
    Component,
    activeQuestionnaireAssignment,
    accessTypes,
    onAction,
    idx,
    edit,
    defaultMode,
    SectionComponents,
    values,
    parsedValues,
    // setParsedValues
}) {
    const { GetComponentValues, SetResponse, ComponentAnswers } = useContext(QuestionnaireBuilderContext)
    const [mode, setMode] = useState(edit ? '' : '')
    const [responseText, setResponseText] = useState()

    const onSetData = (text) => SetResponse(Component, text, true)
    const _ComponentValues = parsedValues ? parsedValues : GetComponentValues(Component.id)

    // useEffect(() => { setParsedValues(responseText) }, [responseText])

    useEffect(() => {
        const Render = async () => {
            if (edit) return setResponseText(Object.keys(_ComponentValues).includes('Question') ? _ComponentValues["Question"] : "")
            let answer = _ComponentValues[Component.id]

            if (answer !== undefined && answer !== '' && answer.indexOf("{{") === -1) return setResponseText(answer)

            const ret = Object.keys(_ComponentValues).includes('Question') ? _ComponentValues["Question"] : ""
            // const ret = properties.find(p => p.property === 'Question').values
            // Just set response to placeholder if in edit mode
            // if (edit) return setResponseValue(JSON.parse(ret))

            if (ret && ret.indexOf('\{\{') > 0) {
                // Check placeholders
                const r = await Data.RenderText({
                    text: ret,
                    //facilityId: 0,
                    patientUserId: activeQuestionnaireAssignment.assignedTo.id
                }).catch((e) => {
                    console.error('DEBUG::(RenderText::Error)', e)
                    // Faillback to default question values
                    // onSetData(ret, isDynamic)
                    // setResponseValue(JSON.parse(ret))
                    setResponseText(ret)
                    onSetData(ret)
                })
                setResponseText(r.text)
                onSetData(r.text)
            } else {
                setResponseText(ret)
                onSetData(ret)
            }
        }
        Render()
    }, [_ComponentValues])

    return <CommonLayoutWrapper
        OnEdit={() => setMode('Edit Text')}
        edit={edit}
        mode={mode}
        accessTypes={accessTypes}
        AdminMode={<AdminLayoutWrapper
            Component={Component}
            mode={mode}
            setMode={setMode}
            Tabs={{
                "Edit Text": {
                    mode: "Set Text",
                    component: <AdminEditText setResponseText={setResponseText} Component={Component} />
                },
                "Dynamic Text": {
                    mode: "Dynamic Text",
                    component: <AdminDynamicText Component={Component} />
                },
            }}
        />}
        NormalMode={
            <>
                <RTEMessageBuilderComponentNew
                    key={`RTE`}
                    viewOnly={true}
                    //readOnly={_ComponentValues[Component.id]["isDynamic"] ? JSON.parse(_ComponentValues[Component.id]["isDynamic"]) === true : true}
                    template={responseText}
                    onSetTemplate={(template, html, md) => accessTypes.includes('Edit') ? SetResponse(Component, template, true) : () => { }}
                />
            </>
        }
    />
}

const AdminDynamicText = ({ Component, parsedValues }) => {
    const { SetComponentValue, GetComponentValues } = useContext(QuestionnaireBuilderContext)
    const _ComponentValues = parsedValues ? parsedValues : GetComponentValues(Component.id)
    return (
        <div onClick={() => SetComponentValue(Component, "isDynamic", JSON.stringify(!_ComponentValues["isDynamic"] ? "true" : !JSON.parse(_ComponentValues["isDynamic"])))} className='text-start ms-3 d-flex align-items-center'>
            <div>
                {
                    _ComponentValues["isDynamic"] && JSON.parse(_ComponentValues["isDynamic"])
                        ?
                        <CheckSquare className='me-2' size={20} />
                        :
                        <Square className='me-2' size={20} />
                }
            </div>
            <div>
                <b>Dynamic</b>
                <p className='p-0 m-0'>This will allow the person filling in the form/questionnaire to change this text</p>
            </div>
        </div>
    )
}